import { useRef } from 'react';

export interface FilePickerOptions {
  /** As the `accept` attribute: `image/*`, `.png,.jpg`. */
  accept?: string;
  multiple?: boolean;
  /** Called with at least one file; the same file can be picked again right after. */
  onFiles: (files: File[]) => void;
}

/**
 * The system file dialog, opened from any control of the kit: render `input` anywhere in the component and
 * call `open` from a `Button`, an `IconButton` or a `Pressable`. The trigger keeps its own look and focus.
 */
export const useFilePicker = ({ accept, multiple, onFiles }: FilePickerOptions) => {
  const ref = useRef<HTMLInputElement>(null);

  const input = (
    <input
      ref={ref}
      type="file"
      hidden
      accept={accept}
      multiple={multiple}
      onChange={(event) => {
        const files = Array.from(event.target.files ?? []);
        // Cleared, or picking the same file again would fire no change.
        event.target.value = '';
        if (files.length) onFiles(files);
      }}
    />
  );

  return { input, open: () => ref.current?.click() };
};
